import { render, staticRenderFns } from "./ProgramForm.vue?vue&type=template&id=13a339ca&scoped=true&"
import script from "./ProgramForm.vue?vue&type=script&lang=ts&"
export * from "./ProgramForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramForm.vue?vue&type=style&index=0&id=13a339ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a339ca",
  null
  
)

export default component.exports